export function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router/es/PromiseUtils.js
// module id = 217
// module chunks = 0